import { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab, { TabProps } from "@mui/material/Tab";
import CloudDownloadSharpIcon from "@mui/icons-material/CloudDownloadSharp";
import TableViewSharpIcon from "@mui/icons-material/TableViewSharp";
import { styled } from "@mui/material/styles";

// import BuildersLogo from "@components/BuildersLogo";
import { InvoiceGenerator } from "@components/invoice/InvoiceGenerator";
import { InvoiceSummary } from "@components/invoice/InvoiceSummary";
import { InvoiceCurrentPeriod } from "@components/invoice/InvoiceCurrentPeriod";
import { IPlantSelect } from "./HoursUpload";
import axiosClient from "@service/axiosClient";
import { IPlantDTO } from "@interfaces/IPlantDTO";

const AntTabs = styled(Tabs)({
  borderBottom: "1px solid #e8e8e8",
  "& .MuiTabs-indicator": {
    backgroundColor: "#1890ff",
  },
});

const AntTab = styled((props: TabProps) => <Tab disableRipple {...props} />)(
  ({ theme }) => ({
    textTransform: "none",
    minWidth: 0,
    [theme.breakpoints.up("sm")]: {
      minWidth: 0,
    },
    fontWeight: theme.typography.fontWeightRegular,
    marginRight: theme.spacing(1),
    color: "rgba(0, 0, 0, 0.85)",
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    "&:hover": {
      color: "rgb(22, 102, 194)",
      opacity: 1,
    },
    "&.Mui-selected": {
      color: "rgb(22, 102, 194)",
      fontWeight: theme.typography.fontWeightMedium,
    },
    "&.Mui-focusVisible": {
      backgroundColor: "#d1eaff",
    },
  })
);

export function InvoicePage(): JSX.Element {
  const [tabIndex, setTabIndex] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [plantsSelect, setPlantsSelect] = useState<IPlantSelect[]>([]);
  const [plants, setPlants] = useState<IPlantDTO[]>([]);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabIndex(newValue);
  };

  useEffect(() => {
    async function fetchPlants() {
      setIsLoading(false);
      try {
        const response = await axiosClient.get("/auth/info/admin");
        setPlants(response.data.plants ?? []);
        setPlantsSelect(
          (response.data.plants ?? []).map((plant: IPlantDTO) => ({
            id: plant.id,
            value: plant.name,
          }))
        );
      } catch (error) {
        console.error("Error fetching plants:", error);
      }
    }
    if (isLoading) {
      fetchPlants();
    }
  }, [isLoading]);

  return (
    <div className="tw-flex tw-flex-col tw-w-full tw-h-full">
      <Box
        className="tw-flex tw-flex-col tw-h-full"
        display="flex"
        marginLeft={35.5}
      >
        <div className="tw-flex tw-flex-col">
          {/* <div className="tw-flex tw-mt-6 tw-mb-2">
                <BuildersLogo/>
            </div> */}

          {/* TABS */}
          <Box sx={{ borderColor: "divider" }}>
            <AntTabs
              value={tabIndex}
              onChange={handleChange}
              aria-label="icon label tabs example"
            >
              <AntTab
                icon={<CloudDownloadSharpIcon />}
                iconPosition="start"
                label="Invoice Generator"
              />
              <AntTab
                icon={<TableViewSharpIcon />}
                iconPosition="start"
                label="Current Invoice Period"
              />
              <AntTab
                icon={<CloudDownloadSharpIcon />}
                iconPosition="start"
                label="Invoice Summary"
              />
            </AntTabs>
          </Box>

          {/* Invoice generator */}
          <div
            className={`tw-border tw-rounded-lg tw-p-2 tw-text-xs tw-shadow-md tw-leading-5 tw-w-[28rem] tw-mt-3 ${
              tabIndex === 0 ? "" : "hidden"
            }`}
          >
            <InvoiceGenerator plants={plantsSelect} />
          </div>

          {/* Current Invoice Period */}
          <div
            className={`tw-border tw-rounded-lg tw-p-2 tw-text-xs tw-shadow-md tw-leading-5 tw-w-[68rem] tw-mt-3 ${
              tabIndex === 1 ? "" : "hidden"
            }`}
          >
            <InvoiceCurrentPeriod plants={plants} />
          </div>

          {/* Invoice Summary */}
          <div
            className={`tw-border tw-rounded-lg tw-p-2 tw-text-xs tw-shadow-md tw-leading-5 tw-w-[28rem] tw-mt-3 ${
              tabIndex === 2 ? "" : "hidden"
            }`}
          >
            <InvoiceSummary plants={plantsSelect} />
          </div>
        </div>
      </Box>
    </div>
  );
}
